module.exports = __webpack_public_path__ + "img/logo.5d7ad5d7.svg";